var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1093_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1061 21.2689C50.7051 19.6989 50.3743 17.8524 49.1112 16.5893L34.1531 1.63123C32.4396 -0.0822508 29.6516 -0.0820556 27.9383 1.63123L11.1218 18.4478H4.79297C2.36982 18.4478 0.398438 20.4192 0.398438 22.8424V45.9495C0.398438 48.3726 2.36982 50.344 4.79297 50.344H46.0039C48.4271 50.344 50.3984 48.3726 50.3984 45.9495V22.8424C50.3984 22.288 50.2942 21.7578 50.1061 21.2689ZM46.9244 18.5456C46.6274 18.482 46.3196 18.4478 46.0039 18.4478H42.8298L44.8282 16.4494L46.9244 18.5456ZM42.7566 14.3778L38.6866 18.4478H34.5433L40.685 12.3061L42.7566 14.3778ZM30.01 3.70281C30.2956 3.41726 30.6707 3.27439 31.0458 3.27439C31.4209 3.27439 31.796 3.41726 32.0815 3.70281L38.6134 10.2346L30.4001 18.4479H15.2648L30.01 3.70281ZM47.4688 45.9495C47.4688 46.7572 46.8116 47.4143 46.0039 47.4143H4.79297C3.98525 47.4143 3.32812 46.7572 3.32812 45.9495V22.8424C3.32812 22.0346 3.98525 21.3775 4.79297 21.3775H46.0039C46.8116 21.3775 47.4688 22.0346 47.4688 22.8424V45.9495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16016 40.0508H12.9866V42.9805H6.16016V40.0508Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7109 40.0508H23.5373V42.9805H16.7109V40.0508Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2598 40.0508H34.0861V42.9805H27.2598V40.0508Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8105 40.0508H44.637V42.9805H37.8105V40.0508Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7058 25.2837H8.69922C7.35303 25.2837 6.25781 26.3789 6.25781 27.7251V31.6314C6.25781 32.9775 7.35303 34.0728 8.69922 34.0728H13.7058C15.052 34.0728 16.1472 32.9775 16.1472 31.6314V27.7251C16.1472 26.3789 15.052 25.2837 13.7058 25.2837ZM13.2175 31.1431H9.1875V28.2134H13.2175V31.1431Z",
    fill: "#3C3C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1093_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.398438 0.345215)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.9c9d3c99d069ac8d4b4a08d29d8af046.svg";
export { ForwardRef as ReactComponent };